(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyDrawer", [], factory);
	else if(typeof exports === 'object')
		exports["hyDrawer"] = factory();
	else
		root["hyDrawer"] = factory();
})(window, function() {
return 